import { defineComponent as a, createElementBlock as i, openBlock as l, createElementVNode as o } from "vue";
const v = a({ name: "IconAdd" }), d = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [s, r] of n)
    e[s] = r;
  return e;
}, p = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function h(t, n, e, s, r, c) {
  return l(), i("svg", p, n[0] || (n[0] = [
    o("g", {
      id: "add",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm.5 2v3.5H12v1H8.5V12h-1V8.499L4 8.5v-1l3.5-.001V4h1Z"
      })
    ], -1)
  ]));
}
const $ = /* @__PURE__ */ d(v, [["render", h]]), w = a({ name: "IconAdministrator" }), _ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function u(t, n, e, s, r, c) {
  return l(), i("svg", _, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M7 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM10.964 13.5c.036.307.036.5.036.5v.5H3V14s0-.193.036-.5c.136-1.172.793-4 3.964-4 3.17 0 3.828 2.828 3.964 4Zm-6.92 0c.048-.355.152-.853.37-1.344.202-.454.484-.86.873-1.153.378-.283.914-.503 1.713-.503s1.335.22 1.713.503c.39.293.671.7.873 1.153a5.045 5.045 0 0 1 .37 1.344H4.044ZM11.5 4.388a.888.888 0 1 1 0-1.775.888.888 0 0 1 0 1.775Zm1.451-.101.294.382a.123.123 0 0 1 0 .15 2.2 2.2 0 0 1-.426.427.123.123 0 0 1-.15 0l-.382-.295c-.1.055-.207.1-.317.132l-.062.478a.123.123 0 0 1-.105.106 2.16 2.16 0 0 1-.605 0 .123.123 0 0 1-.105-.106l-.062-.478a1.64 1.64 0 0 1-.318-.131l-.382.294a.123.123 0 0 1-.15 0 2.218 2.218 0 0 1-.427-.427.123.123 0 0 1 .001-.149l.294-.382a1.64 1.64 0 0 1-.132-.318l-.478-.063a.123.123 0 0 1-.106-.105 2.214 2.214 0 0 1 0-.604.123.123 0 0 1 .106-.105l.478-.062a1.64 1.64 0 0 1 .132-.318l-.294-.383a.123.123 0 0 1 0-.149c.121-.16.268-.307.427-.427a.123.123 0 0 1 .149 0l.382.295c.101-.055.207-.1.318-.132l.062-.478a.123.123 0 0 1 .105-.105c.205-.029.4-.029.605 0 .054.007.097.05.105.106l.062.478c.11.032.217.076.317.131l.382-.294a.123.123 0 0 1 .15 0 2.2 2.2 0 0 1 .427.427.123.123 0 0 1 0 .15l-.295.382c.055.1.099.206.132.317l.477.062c.055.007.099.05.106.105.029.206.028.4 0 .604a.123.123 0 0 1-.106.105l-.477.063c-.033.11-.077.216-.132.317Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const m = /* @__PURE__ */ d(w, [["render", u]]), g = a({ name: "IconAlertFill" }), f = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function x(t, n, e, s, r, c) {
  return l(), i("svg", f, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/alert-fill",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1ZM7 3h2v6H7V3Zm1 7.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      })
    ], -1)
  ]));
}
const Z = /* @__PURE__ */ d(g, [["render", x]]), V = a({ name: "IconAlert" }), I = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function H(t, n, e, s, r, c) {
  return l(), i("svg", I, n[0] || (n[0] = [
    o("g", {
      id: "alert",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 13A6 6 0 1 0 8 2a6 6 0 0 0 0 12ZM7.5 4h1v5.5h-1V4Zm.5 6.5A.75.75 0 1 1 8 12a.75.75 0 0 1 0-1.5Z"
      })
    ], -1)
  ]));
}
const M = /* @__PURE__ */ d(V, [["render", H]]), L = a({ name: "IconAnalog" }), k = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function B(t, n, e, s, r, c) {
  return l(), i("svg", k, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/other/analog",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path",
        d: "M3.5 3.001v5.006l.007.144A1.5 1.5 0 0 0 4.85 9.5l.144.007 6.629.023-.002-.031L9.33 7.207l.707-.707 3.536 3.536-3.536 3.535-.707-.707 2.332-2.334-6.67-.023-.165-.006a2.5 2.5 0 0 1-2.322-2.33L2.5 8.007V3.001h1Z"
      })
    ], -1)
  ]));
}
const C = /* @__PURE__ */ d(L, [["render", B]]), S = a({ name: "IconArrowDown" }), A = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function b(t, n, e, s, r, c) {
  return l(), i("svg", A, n[0] || (n[0] = [
    o("g", {
      id: "arrow-down",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path-Copy",
        d: "m8 1 5 5.257-.707.743L8.5 3.012V15h-1V3.012L3.707 7 3 6.257z",
        transform: "rotate(-180 8 8)"
      })
    ], -1)
  ]));
}
const D = /* @__PURE__ */ d(S, [["render", b]]), z = a({ name: "IconArrowLeftBottom" }), y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function F(t, n, e, s, r, c) {
  return l(), i("svg", y, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/navigation/arrow-left-bottom",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path",
        d: "m12.743 2.55.707.707L4.707 12 10 12v1H3V6h1v5.292z"
      })
    ], -1)
  ]));
}
const P = /* @__PURE__ */ d(z, [["render", F]]), E = a({ name: "IconArrowLeftTop" }), O = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function U(t, n, e, s, r, c) {
  return l(), i("svg", O, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/navigation/arrow-left-top",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path",
        d: "m12.743 13 .707-.707L4.707 3.55H10v-1H3v7h1V4.257z"
      })
    ], -1)
  ]));
}
const T = /* @__PURE__ */ d(E, [["render", U]]), R = a({ name: "IconArrowLeft" }), q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function G(t, n, e, s, r, c) {
  return l(), i("svg", q, n[0] || (n[0] = [
    o("g", {
      id: "arrow-left",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path-Copy",
        d: "m8 1 5 5.257-.707.743L8.5 3.012V15h-1V3.012L3.707 7 3 6.257z",
        transform: "rotate(-90 8 8)"
      })
    ], -1)
  ]));
}
const Q = /* @__PURE__ */ d(R, [["render", G]]), j = a({ name: "IconArrowRightBottom" }), N = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function W(t, n, e, s, r, c) {
  return l(), i("svg", N, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/navigation/arrow-right-bottom",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path",
        d: "M3.707 2.55 3 3.257 11.743 12 6.45 12v1h7V6h-1v5.292z"
      })
    ], -1)
  ]));
}
const J = /* @__PURE__ */ d(j, [["render", W]]), K = a({ name: "IconArrowRightTop" }), Y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function X(t, n, e, s, r, c) {
  return l(), i("svg", Y, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/navigation/arrow-right-top",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path",
        d: "M3.707 13 3 12.293l8.743-8.742H6.45v-1h7v7h-1V4.257z"
      })
    ], -1)
  ]));
}
const n1 = /* @__PURE__ */ d(K, [["render", X]]), o1 = a({ name: "IconArrowRight" }), t1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function e1(t, n, e, s, r, c) {
  return l(), i("svg", t1, n[0] || (n[0] = [
    o("g", {
      id: "arrow-right",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path-Copy-2",
        d: "m8 1 5 5.257-.707.743L8.5 3.012V15h-1V3.012L3.707 7 3 6.257z",
        transform: "rotate(90 8 8)"
      })
    ], -1)
  ]));
}
const s1 = /* @__PURE__ */ d(o1, [["render", e1]]), r1 = a({ name: "IconArrowUp" }), a1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function i1(t, n, e, s, r, c) {
  return l(), i("svg", a1, n[0] || (n[0] = [
    o("g", {
      id: "arrow-up",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path",
        d: "m8 1 5 5.257-.707.743L8.5 3.012V15h-1V3.012L3.707 7 3 6.257z"
      })
    ], -1)
  ]));
}
const l1 = /* @__PURE__ */ d(r1, [["render", i1]]), d1 = a({ name: "IconArrowsVertical" }), c1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function v1(t, n, e, s, r, c) {
  return l(), i("svg", c1, n[0] || (n[0] = [
    o("g", {
      id: "arrows-vertical",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "m4.5 2 3 3.2-.75.8L5 4.134V14H4V4.133L2.25 6l-.75-.8 3-3.2ZM12 2l-.001 9.867L13.75 10l.75.8-3 3.2-3-3.2.75-.8 1.749 1.865L11 2h1Z"
      })
    ], -1)
  ]));
}
const p1 = /* @__PURE__ */ d(d1, [["render", v1]]), h1 = a({ name: "IconBold" }), $1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function w1(t, n, e, s, r, c) {
  return l(), i("svg", $1, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M4 2h4.5a3.5 3.5 0 0 1 2.852 5.53A3.5 3.5 0 0 1 9.5 14H4V2Zm2 5h2.5a1.5 1.5 0 1 0 0-3H6v3Zm0 2v3h3.5a1.5 1.5 0 0 0 0-3H6Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _1 = /* @__PURE__ */ d(h1, [["render", w1]]), u1 = a({ name: "IconBookmarkFill" }), m1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function g1(t, n, e, s, r, c) {
  return l(), i("svg", m1, n[0] || (n[0] = [
    o("path", { d: "M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v13l-5-3-5 3V2Z" }, null, -1)
  ]));
}
const f1 = /* @__PURE__ */ d(u1, [["render", g1]]), x1 = a({ name: "IconBookmark" }), Z1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function V1(t, n, e, s, r, c) {
  return l(), i("svg", Z1, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "m8 12 5 3V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v13l5-3Zm-4 1.234 4-2.4 4 2.4V2H4v11.234Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const I1 = /* @__PURE__ */ d(x1, [["render", V1]]), H1 = a({ name: "IconCalendar" }), M1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function L1(t, n, e, s, r, c) {
  return l(), i("svg", M1, n[0] || (n[0] = [
    o("g", {
      id: "calendar",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M11 2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1v-.5a.5.5 0 0 1 1 0V2h4v-.5a.5.5 0 1 1 1 0V2Zm-1 1H6v.5a.5.5 0 0 1-1 0V3H4a1 1 0 0 0-1 1v1h10v1H3v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-1v.5a.5.5 0 1 1-1 0V3Z"
      })
    ], -1)
  ]));
}
const k1 = /* @__PURE__ */ d(H1, [["render", L1]]), B1 = a({ name: "IconCardBank" }), C1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function S1(t, n, e, s, r, c) {
  return l(), i("svg", C1, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/other/card-bank",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M13.5 3.5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h11Zm0 3h-11v5h11v-5Zm-5 3.5v1h-5v-1h5Zm5-5.5h-11v1h11v-1Z"
      })
    ], -1)
  ]));
}
const A1 = /* @__PURE__ */ d(B1, [["render", S1]]), b1 = a({ name: "IconCategory" }), D1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function z1(t, n, e, s, r, c) {
  return l(), i("svg", D1, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/other/category",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M12 9H8.5v2h1v3h-3v-3h1V9H4v2h1v3H2v-3h1V8h4.5V6H6V2h4v4H8.5v2H13v3h1v3h-3v-3h1V9Zm-3.5 3h-1v1h1v-1Zm4.5 0h-1v1h1v-1Zm-9 0H3v1h1v-1Zm5-9H7v2h2V3Z"
      })
    ], -1)
  ]));
}
const y1 = /* @__PURE__ */ d(b1, [["render", z1]]), F1 = a({ name: "IconCheckFill" }), P1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function E1(t, n, e, s, r, c) {
  return l(), i("svg", P1, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/check-fill",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm2.927 4.58L7.318 9.229 5.495 7.7l-.973 1.223 2.87 2.56 4.584-4.827-1.049-1.075Z"
      })
    ], -1)
  ]));
}
const O1 = /* @__PURE__ */ d(F1, [["render", E1]]), U1 = a({ name: "IconCheck" }), T1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function R1(t, n, e, s, r, c) {
  return l(), i("svg", T1, n[0] || (n[0] = [
    o("g", {
      id: "check",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 13A6 6 0 1 0 8 2a6 6 0 0 0 0 12ZM5.188 8.176l2.147 1.916 3.916-4.124.725.688-4.583 4.827-2.87-2.56.665-.747Z"
      })
    ], -1)
  ]));
}
const q1 = /* @__PURE__ */ d(U1, [["render", R1]]), G1 = a({ name: "IconCheckboxFill" }), Q1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function j1(t, n, e, s, r, c) {
  return l(), i("svg", Q1, n[0] || (n[0] = [
    o("g", {
      id: "checkbox-fill",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M13 1H2.977C1.853 1 1 2.001 1 2.985v10.03C1 14.213 1.944 15 2.977 15H13c1.114 0 2-.89 2-1.986V2.984C15 2.097 14.27 1 13 1Zm-1.966 4.15.884.884-4.884 4.884L4.15 8.034l.884-.884 2 2 4-4Z"
      })
    ], -1)
  ]));
}
const N1 = /* @__PURE__ */ d(G1, [["render", j1]]), W1 = a({ name: "IconCheckbox" }), J1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function K1(t, n, e, s, r, c) {
  return l(), i("svg", J1, n[0] || (n[0] = [
    o("g", {
      id: "checkbox",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10Zm0 1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-2 3.293.707.707L7 10.707 4.293 8 5 7.293l2 2 4-4Z"
      })
    ], -1)
  ]));
}
const Y1 = /* @__PURE__ */ d(W1, [["render", K1]]), X1 = a({ name: "IconChevronDown" }), n0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function o0(t, n, e, s, r, c) {
  return l(), i("svg", n0, n[0] || (n[0] = [
    o("g", {
      id: "Chevron-down",
      "stroke-width": "1"
    }, [
      o("mask", { id: "mask-2" }, [
        o("path", { d: "M3 5.743 3.707 5 8 9.513 12.293 5l.707.743L8 11z" })
      ]),
      o("path", { d: "M3 5.743 3.707 5 8 9.513 12.293 5l.707.743L8 11z" })
    ], -1)
  ]));
}
const t0 = /* @__PURE__ */ d(X1, [["render", o0]]), e0 = a({ name: "IconChevronLeft" }), s0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function r0(t, n, e, s, r, c) {
  return l(), i("svg", s0, n[0] || (n[0] = [
    o("g", {
      id: "Chevron-left",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "arrow",
        d: "m12.275 11 .725-.699L7.998 5 3 10.301l.725.699 4.273-4.533z",
        transform: "rotate(-90 8 8)"
      })
    ], -1)
  ]));
}
const a0 = /* @__PURE__ */ d(e0, [["render", r0]]), i0 = a({ name: "IconChevronRight" }), l0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function d0(t, n, e, s, r, c) {
  return l(), i("svg", l0, n[0] || (n[0] = [
    o("g", {
      id: "Chevron-right",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "arrow",
        d: "m12.275 11 .725-.699L7.998 5 3 10.301l.725.699 4.273-4.533z",
        transform: "rotate(90 8 8)"
      })
    ], -1)
  ]));
}
const c0 = /* @__PURE__ */ d(i0, [["render", d0]]), v0 = a({ name: "IconChevronUp" }), p0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function h0(t, n, e, s, r, c) {
  return l(), i("svg", p0, n[0] || (n[0] = [
    o("g", {
      id: "Chevron-up",
      "stroke-width": "1"
    }, [
      o("mask", { id: "mask-2" }, [
        o("path", { d: "M3 10.257 8 5l5 5.257-.707.743L8 6.487 3.707 11z" })
      ]),
      o("path", { d: "M3 10.257 8 5l5 5.257-.707.743L8 6.487 3.707 11z" })
    ], -1)
  ]));
}
const $0 = /* @__PURE__ */ d(v0, [["render", h0]]), w0 = a({ name: "IconChocholateMenu" }), _0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function u0(t, n, e, s, r, c) {
  return l(), i("svg", _0, n[0] || (n[0] = [
    o("g", {
      id: "chocholate-menu",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M14 12v2h-2v-2h2Zm-5 0v2H7v-2h2Zm-5 0v2H2v-2h2Zm0-5v2H2V7h2Zm10 0v2h-2V7h2ZM9 7v2H7V7h2ZM4 2v2H2V2h2Zm10 0v2h-2V2h2ZM9 2v2H7V2h2Z"
      })
    ], -1)
  ]));
}
const m0 = /* @__PURE__ */ d(w0, [["render", u0]]), g0 = a({ name: "IconChocolateMenu" }), f0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function x0(t, n, e, s, r, c) {
  return l(), i("svg", f0, n[0] || (n[0] = [
    o("g", {
      id: "chocholate-menu",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M14 12v2h-2v-2h2Zm-5 0v2H7v-2h2Zm-5 0v2H2v-2h2Zm0-5v2H2V7h2Zm10 0v2h-2V7h2ZM9 7v2H7V7h2ZM4 2v2H2V2h2Zm10 0v2h-2V2h2ZM9 2v2H7V2h2Z"
      })
    ], -1)
  ]));
}
const Z0 = /* @__PURE__ */ d(g0, [["render", x0]]), V0 = a({ name: "IconClockFill" }), I0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function H0(t, n, e, s, r, c) {
  return l(), i("svg", I0, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1ZM7 9h5V7.5H8.5V4H7v5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const M0 = /* @__PURE__ */ d(V0, [["render", H0]]), L0 = a({ name: "IconClock" }), k0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function B0(t, n, e, s, r, c) {
  return l(), i("svg", k0, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/time/сlock",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm0 2v4h4v1H7V4h1Z"
      })
    ], -1)
  ]));
}
const C0 = /* @__PURE__ */ d(L0, [["render", B0]]), S0 = a({ name: "IconCollapse" }), A0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function b0(t, n, e, s, r, c) {
  return l(), i("svg", A0, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M1 3v10h1V3H1Zm2 5.017.71.705L6 11l.705-.71L4.92 8.516 15.001 8.5l-.002-1-10.09.015 1.8-1.81L6 5 3.705 7.308 3 8.018Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const D0 = /* @__PURE__ */ d(S0, [["render", b0]]), z0 = a({ name: "IconComment" }), y0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function F0(t, n, e, s, r, c) {
  return l(), i("svg", y0, n[0] || (n[0] = [
    o("g", {
      id: "comment",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M14 2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.001L13 13.793a.5.5 0 0 1-.095.293l-.051.06a.5.5 0 0 1-.638.058l-.07-.058L9 11H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12Zm0 1H2v7h7.413L12 12.59 11.999 10H14V3ZM9 7v1H4V7h5Zm3-2v1H4V5h8Z"
      })
    ], -1)
  ]));
}
const P0 = /* @__PURE__ */ d(z0, [["render", F0]]), E0 = a({ name: "IconCompany" }), O0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function U0(t, n, e, s, r, c) {
  return l(), i("svg", O0, n[0] || (n[0] = [
    o("g", {
      id: "company",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "company",
        d: "M1 15v-1h1V2h7v2h5v10h1v1H1ZM8 3H3v11h5V3Zm5 2H9v1h3v1H9v1h3v1H9v1h3v1H9v1h3v1H9v1h4V5Zm-8 7v1H4v-1h1Zm2 0v1H6v-1h1Zm-2-2v1H4v-1h1Zm2 0v1H6v-1h1ZM5 8v1H4V8h1Zm2 0v1H6V8h1ZM5 6v1H4V6h1Zm2 0v1H6V6h1ZM4 4h1v1H4V4Zm2 0h1v1H6V4Z"
      })
    ], -1)
  ]));
}
const T0 = /* @__PURE__ */ d(E0, [["render", U0]]), R0 = a({ name: "IconCompare" }), q0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function G0(t, n, e, s, r, c) {
  return l(), i("svg", q0, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/operations/compare",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M4 9v5H3V9h1Zm3-7v12H6V2h1Zm3 2v10H9V4h1Zm3 3v7h-1V7h1Z"
      })
    ], -1)
  ]));
}
const Q0 = /* @__PURE__ */ d(R0, [["render", G0]]), j0 = a({ name: "IconCopy" }), N0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function W0(t, n, e, s, r, c) {
  return l(), i("svg", N0, n[0] || (n[0] = [
    o("g", {
      id: "сopy",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M13.75 5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25h-7.5C5.56 15 5 14.44 5 13.75v-7.5C5 5.56 5.56 5 6.25 5h7.5ZM14 6H6v8h8V6ZM9.75 1c.69 0 1.25.56 1.25 1.25V4h-1V2H2v8h2v1H2.25C1.56 11 1 10.44 1 9.75v-7.5C1 1.56 1.56 1 2.25 1h7.5Z"
      })
    ], -1)
  ]));
}
const J0 = /* @__PURE__ */ d(j0, [["render", W0]]), K0 = a({ name: "IconDataCards" }), Y0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function X0(t, n, e, s, r, c) {
  return l(), i("svg", Y0, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/operations/data-cards",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M15 9v4H1V9h14Zm-1 1H2v2h12v-2Zm1-7v4H1V3h14Zm-1 1H2v2h12V4Z"
      })
    ], -1)
  ]));
}
const n2 = /* @__PURE__ */ d(K0, [["render", X0]]), o2 = a({ name: "IconDelete" }), t2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function e2(t, n, e, s, r, c) {
  return l(), i("svg", t2, n[0] || (n[0] = [
    o("g", {
      id: "delete",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M10 2H6v1h4V2Zm2 2H4v10h8V4Zm-2 1v8H9V5h1ZM7 5v8H6V5h1Zm7-2v1h-1v11H3V4H2V3h3V1h6v2h3Z"
      })
    ], -1)
  ]));
}
const s2 = /* @__PURE__ */ d(o2, [["render", e2]]), r2 = a({ name: "IconDirectoryOpen" }), a2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function i2(t, n, e, s, r, c) {
  return l(), i("svg", a2, n[0] || (n[0] = [
    o("g", { "clip-path": "url(#clip0_2734_854)" }, [
      o("path", {
        "fill-rule": "evenodd",
        d: "M1.034 2.548a.5.5 0 0 1 .41-.492l.09-.008h2.96a.5.5 0 0 1 .392.188l.05.077.928 1.739h8.62a.5.5 0 0 1 .491.41l.008.09V7h.517a.5.5 0 0 1 .493.582l-1 6A.5.5 0 0 1 14.5 14H2l-.004-.003h-.462a.5.5 0 0 1-.492-.411l-.008-.09V2.548ZM3 13v-.004h-.859L3.391 8H14.91l-.834 5H3Zm10.983-7.948L14 7H3a.5.5 0 0 0-.485.379l-.482 1.928V3.047h2.161L5.25 5.023v.03l8.733-.001Z",
        "clip-rule": "evenodd"
      })
    ], -1),
    o("defs", null, [
      o("clipPath", { id: "clip0_2734_854" }, [
        o("path", { d: "M0 0h16v16H0z" })
      ])
    ], -1)
  ]));
}
const l2 = /* @__PURE__ */ d(r2, [["render", i2]]), d2 = a({ name: "IconDirectory" }), c2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function v2(t, n, e, s, r, c) {
  return l(), i("svg", c2, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/file/directory",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M1.034 2.548a.5.5 0 0 1 .41-.492l.09-.008h2.96a.5.5 0 0 1 .392.188l.05.077.928 1.739h8.62a.5.5 0 0 1 .491.41l.008.09v9a.5.5 0 0 1-.41.492l-.09.008H1.533a.5.5 0 0 1-.491-.41l-.008-.09V2.548Zm.999 10.504h11.95v-8H5.249v-.029L4.195 3.048H2.033v10.004Z"
      })
    ], -1)
  ]));
}
const p2 = /* @__PURE__ */ d(d2, [["render", v2]]), h2 = a({ name: "IconDocDownload" }), $2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function w2(t, n, e, s, r, c) {
  return l(), i("svg", $2, n[0] || (n[0] = [
    o("g", {
      id: "doc-download",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "doc-download",
        d: "M11 8v5.156l2.364-2.363.707.707-3.535 3.536L7 11.5l.707-.707L10 13.086V8h1ZM9 1l3 3v3h-1V5H8V2H3v12h3v1H2V1h7Zm0 1.5v1.499L10.5 4 9 2.5Z"
      })
    ], -1)
  ]));
}
const _2 = /* @__PURE__ */ d(h2, [["render", w2]]), u2 = a({ name: "IconDoc" }), m2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function g2(t, n, e, s, r, c) {
  return l(), i("svg", m2, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/file/doc",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M13 15H3V1h7.018L13 3.991V15ZM9 2H4v12h8V5H9V2Zm1 .397V4h1.597L10 2.397Z"
      })
    ], -1)
  ]));
}
const f2 = /* @__PURE__ */ d(u2, [["render", g2]]), x2 = a({ name: "IconDownload" }), Z2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function V2(t, n, e, s, r, c) {
  return l(), i("svg", Z2, n[0] || (n[0] = [
    o("g", {
      id: "download",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Download",
        d: "m2 12-.001 2H14v-2h1v3H1v-3h1ZM8.5 1v8.156l2.364-2.363.707.707-3.535 3.536L4.5 7.5l.707-.707L7.5 9.086V1h1Z"
      })
    ], -1)
  ]));
}
const I2 = /* @__PURE__ */ d(x2, [["render", V2]]), H2 = a({ name: "IconDraggable" }), M2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function L2(t, n, e, s, r, c) {
  return l(), i("svg", M2, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/navigation/draggable",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M7 11v2H5v-2h2Zm4 0v2H9v-2h2ZM7 7v2H5V7h2Zm4 0v2H9V7h2ZM7 3v2H5V3h2Zm4 0v2H9V3h2Z"
      })
    ], -1)
  ]));
}
const k2 = /* @__PURE__ */ d(H2, [["render", L2]]), B2 = a({ name: "IconEdit" }), C2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function S2(t, n, e, s, r, c) {
  return l(), i("svg", C2, n[0] || (n[0] = [
    o("g", {
      id: "edit",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "m12.88 1.364 1.793 1.793a1 1 0 0 1 .083 1.32l-.083.094L4.207 14.96H1v-3.206L11.466 1.364c.33-.33.834-.38 1.218-.153l.101.07.095.083ZM3.25 10.92 2 12.169v1.793h1.793l1.252-1.249-1.794-1.793Zm10.228-7.717-8.272 8.258.546.546 8.284-8.246-.558-.558Zm-1.236-1.235L3.96 10.215l.539.539 8.272-8.259-.528-.527Z"
      })
    ], -1)
  ]));
}
const A2 = /* @__PURE__ */ d(B2, [["render", S2]]), b2 = a({ name: "IconEducation" }), D2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function z2(t, n, e, s, r, c) {
  return l(), i("svg", D2, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M2.727 5.29 8 7.667l5.273-2.379L8 3.02l-5.273 2.27ZM1.3 4.837a.474.474 0 0 0-.008.88L7.78 8.642a.54.54 0 0 0 .442 0l6.487-2.926a.474.474 0 0 0-.008-.879L8.213 2.044a.54.54 0 0 0-.426 0L1.3 4.838Z",
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      d: "M3.38 5.754a.5.5 0 0 1 .513.485v3.396a.5.5 0 0 1-.513.485.5.5 0 0 1-.514-.485V6.239a.5.5 0 0 1 .514-.485ZM12.62 5.754a.5.5 0 0 1 .514.485v3.396a.5.5 0 0 1-.514.485.5.5 0 0 1-.513-.485V6.239a.5.5 0 0 1 .513-.485ZM11.08 6.24a.5.5 0 0 1 .514.484v6.791a.5.5 0 0 1-.514.485.5.5 0 0 1-.513-.485v-6.79a.5.5 0 0 1 .513-.486Z",
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      d: "M11.54 6.941a.528.528 0 0 1-.69.217L7.77 5.703a.473.473 0 0 1-.23-.65.528.528 0 0 1 .69-.218l3.08 1.456c.253.12.356.41.23.65ZM3.036 9.275a.535.535 0 0 1 .724.034l-.38.326.38-.326.002.002.012.012.054.052c.05.047.125.116.225.2.2.168.497.394.874.62.758.454 1.818.895 3.073.895s2.315-.44 3.073-.895c.377-.226.673-.452.874-.62a5.035 5.035 0 0 0 .28-.252l.011-.012.001-.001a.535.535 0 0 1 .725-.035c.21.18.227.486.037.685l-.38-.325.38.325v.001l-.003.002-.006.007-.02.02a6.03 6.03 0 0 1-.343.31 7.898 7.898 0 0 1-1.006.714C10.762 11.53 9.51 12.06 8 12.06c-1.511 0-2.762-.53-3.623-1.046a7.9 7.9 0 0 1-1.005-.713 6.077 6.077 0 0 1-.344-.31l-.02-.021-.006-.007L3 9.961s-.001-.001.38-.326L3 9.96a.467.467 0 0 1 .036-.685Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const y2 = /* @__PURE__ */ d(b2, [["render", z2]]), F2 = a({ name: "IconEnter" }), P2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function E2(t, n, e, s, r, c) {
  return l(), i("svg", P2, n[0] || (n[0] = [
    o("g", {
      id: "enter",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "enter",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm1 3.172L11.828 8 9 10.828l-.707-.707L9.914 8.5H4v-1h5.914L8.293 5.879 9 5.172Z"
      })
    ], -1)
  ]));
}
const O2 = /* @__PURE__ */ d(F2, [["render", E2]]), U2 = a({ name: "IconErrorFill" }), T2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function R2(t, n, e, s, r, c) {
  return l(), i("svg", T2, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/error-fill",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1ZM5.172 3.757 3.757 5.172l7.071 7.07 1.415-1.414-7.071-7.07Z"
      })
    ], -1)
  ]));
}
const q2 = /* @__PURE__ */ d(U2, [["render", R2]]), G2 = a({ name: "IconError" }), Q2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function j2(t, n, e, s, r, c) {
  return l(), i("svg", Q2, n[0] || (n[0] = [
    o("g", {
      id: "error",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M1 8c0-3.85 3.15-7 7-7s7 3.15 7 7-3.15 7-7 7-7-3.15-7-7Zm11.55 3.85C13.5 10.8 14 9.4 14 8c0-3.3-2.7-6-6-6-1.4 0-2.8.5-3.85 1.45l8.4 8.4Zm-8.45.75C5.2 13.5 6.6 14 8 14s2.8-.5 3.85-1.4L3.4 4.15c-2.1 2.5-1.8 6.3.7 8.45Z"
      })
    ], -1)
  ]));
}
const N2 = /* @__PURE__ */ d(G2, [["render", j2]]), W2 = a({ name: "IconExpand" }), J2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function K2(t, n, e, s, r, c) {
  return l(), i("svg", J2, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M2 13V3H1v10h1Zm13-5.017-.71-.705L12 5l-.705.71 1.786 1.775L2.999 7.5l.002 1 10.09-.015-1.8 1.81L12 11l2.295-2.308.705-.71Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y2 = /* @__PURE__ */ d(W2, [["render", K2]]), X2 = a({ name: "IconExternal" }), nn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function on(t, n, e, s, r, c) {
  return l(), i("svg", nn, n[0] || (n[0] = [
    o("g", {
      id: "external",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M7 2v1H3v10h10V9h1v4.143a.857.857 0 0 1-.857.857H2.857A.857.857 0 0 1 2 13.143V2.857C2 2.384 2.384 2 2.857 2H7Zm8-1v6.116h-1.036V2.767L7.732 9 7 8.268l6.232-6.233H8.884V1H15Z"
      })
    ], -1)
  ]));
}
const tn = /* @__PURE__ */ d(X2, [["render", on]]), en = a({ name: "IconFacebookFill" }), sn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function rn(t, n, e, s, r, c) {
  return l(), i("svg", sn, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/social/facebook-fill",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M3 2a1 1 0 0 0-.993.883L2 13a1 1 0 0 0 .883.993l3.99.007V9.955H4.96V7.842h1.914V6.098c-.036-.914.297-1.667 1-2.256.702-.589 1.875-.743 3.52-.462v1.83l-.828.016a7.33 7.33 0 0 0-.773.09c-.12.04-.321.132-.454.3-.139.176-.19.447-.202.622l.024 1.55h2.233l-.482 2.167H9.134L9.158 14H13a1 1 0 0 0 .993-.883L14 3a1 1 0 0 0-.883-.993L3 2Z"
      })
    ], -1)
  ]));
}
const an = /* @__PURE__ */ d(en, [["render", rn]]), ln = a({ name: "IconFacebook" }), dn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function cn(t, n, e, s, r, c) {
  return l(), i("svg", dn, n[0] || (n[0] = [
    o("g", {
      id: "facebook",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM3 2a1 1 0 0 0-.993.883L2 13a1 1 0 0 0 .883.993l3.99.007V9.955H4.96V7.842h1.914V6.098c-.036-.914.297-1.667 1-2.256.702-.589 1.875-.743 3.52-.462v1.83l-.828.016a7.33 7.33 0 0 0-.773.09c-.12.04-.321.132-.454.3-.139.176-.19.447-.202.622l.024 1.55h2.233l-.482 2.167H9.134L9.158 14H13a1 1 0 0 0 .993-.883L14 3a1 1 0 0 0-.883-.993L3 2Z"
      })
    ], -1)
  ]));
}
const vn = /* @__PURE__ */ d(ln, [["render", cn]]), pn = a({ name: "IconFill" }), hn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function $n(t, n, e, s, r, c) {
  return l(), i("svg", hn, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M12.876 6.925a.5.5 0 0 1 .125.345v3.23a.5.5 0 1 1-1 0V8.4l-4.875 4.47a.5.5 0 0 1-.333.13h7.208v2h-12v-2h4.76a.5.5 0 0 1-.345-.165l-4.285-4.76a.5.5 0 0 1 .03-.705l5.34-4.87V1h1v1.1c.03.019.059.04.085.065l4.29 4.76Zm-9.665.845 3.615 4 4.97-4.54-3.295-3.665V6h-1V3.835L3.211 7.77Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wn = /* @__PURE__ */ d(pn, [["render", $n]]), _n = a({ name: "IconFilters" }), un = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function mn(t, n, e, s, r, c) {
  return l(), i("svg", un, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/operations/filter",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M5 11a2 2 0 0 1 1.937 1.5H15v1l-8.063.001a2 2 0 0 1-3.874 0L1 13.5v-1h2.063A2 2 0 0 1 5 11Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm6-6a2 2 0 0 1 1.937 1.5H15v1l-2.063.001a2 2 0 0 1-3.874 0L1 8.5v-1h8.063A2 2 0 0 1 11 6Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 1a2 2 0 0 1 1.937 1.5H15v1l-8.063.001a2 2 0 0 1-3.874 0L1 3.5v-1h2.063A2 2 0 0 1 5 1Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      })
    ], -1)
  ]));
}
const gn = /* @__PURE__ */ d(_n, [["render", mn]]), fn = a({ name: "IconFlag" }), xn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Zn(t, n, e, s, r, c) {
  return l(), i("svg", xn, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/toggle/flag",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path",
        "fill-rule": "nonzero",
        d: "m13.5 2-1.865 3.5L13.5 9h-10v5h-1V2z"
      })
    ], -1)
  ]));
}
const Vn = /* @__PURE__ */ d(fn, [["render", Zn]]), In = a({ name: "IconFormat" }), Hn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Mn(t, n, e, s, r, c) {
  return l(), i("svg", Hn, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "m10 2.414-4.94 4.94 3.586 3.585L13.586 6 10 2.414Zm-2.06 9.232L4.353 8.061 2.414 10 6 13.586l1.94-1.94Zm1.353-9.939-4.94 4.94-.707.707-1.939 1.939a1 1 0 0 0 0 1.414l3.586 3.586a1 1 0 0 0 1.414 0l1.94-1.94.707-.707 4.939-4.939a1 1 0 0 0 0-1.414l-3.586-3.586a1 1 0 0 0-1.414 0ZM14 14H9v1h5v-1Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Ln = /* @__PURE__ */ d(In, [["render", Mn]]), kn = a({ name: "IconFormula" }), Bn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Cn(t, n, e, s, r, c) {
  return l(), i("svg", Bn, n[0] || (n[0] = [
    o("path", { d: "M10 3.5V3a2 2 0 1 0-4 0v3H4.5a.5.5 0 0 0 0 1H6v5.996a1 1 0 1 1-2 0V12.5a.5.5 0 0 0-1 0v.5a2 2 0 0 0 4 .053V7h1.5a.5.5 0 0 0 0-1H7V3a1 1 0 0 1 2 0v.5a.5.5 0 0 0 1 0ZM8.646 9.854a.5.5 0 1 1 .708-.708l1.146 1.147 1.146-1.147a.5.5 0 0 1 .708.708L11.207 11l1.147 1.146a.5.5 0 0 1-.708.708L10.5 11.707l-1.146 1.147a.5.5 0 0 1-.708-.708L9.793 11 8.646 9.854Z" }, null, -1)
  ]));
}
const Sn = /* @__PURE__ */ d(kn, [["render", Cn]]), An = a({ name: "IconFunnel" }), bn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Dn(t, n, e, s, r, c) {
  return l(), i("svg", bn, n[0] || (n[0] = [
    o("g", {
      id: "funnel",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Rectangle",
        "fill-rule": "nonzero",
        d: "M14.005 2v2.12a1 1 0 0 1-.248.659l-3.74 4.263v4.966h-4V9.042L2.251 4.78A1 1 0 0 1 2 4.117V2h12.005Zm-1 1H3v1.117L6.767 8.38l.25.284v4.344h1.999V8.666l.249-.283 3.74-4.264V3Z"
      })
    ], -1)
  ]));
}
const zn = /* @__PURE__ */ d(An, [["render", Dn]]), yn = a({ name: "IconGlobe" }), Fn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Pn(t, n, e, s, r, c) {
  return l(), i("svg", Fn, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/other/workspace/globe",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a6.992 6.992 0 0 1 7 7 7 7 0 1 1-7-7ZM4.85 11.344c-.523.168-.772.403-.95.641l-.111.158-.052.079A5.979 5.979 0 0 0 8 14c1.12 0 2.167-.307 3.064-.84l.054.049c-.677-.65-1.486-.926-2.873-1.061l-.285-.026-.148-.015-.151-.026-.168-.037-.311-.086-.265-.082-1.009-.322-.313-.09c-.355-.125-.603-.165-.745-.12ZM8 2a6.034 6.034 0 0 0-1.437.173c.468.85.685 1.718.417 2.1-.28.4-.565.75-.913 1.044-.675.57-1.41.662-1.872-.104-.243-.404-.25-.798-.12-1.489l.062-.315A5.987 5.987 0 0 0 2 8c0 1.283.403 2.473 1.09 3.448l-.027.03c.309-.366.745-.705 1.31-1.012.342-.186.721-.176 1.398.006l.192.053.397.121.532.172.658.205.175.047.141.031.12.019.339.03c1.661.162 2.688.528 3.566 1.415a5.986 5.986 0 0 0 1.85-2.818l-.115-.303-.128-.304-.118-.251a4.786 4.786 0 0 0-.053-.105c-.064-.151-.109-.227-.134-.227-.019 0-.039.022-.06.066l-.175.382-.104.244-.198.485-.152.35c-.24.523-.443.787-.805.83l-.114.007-.583.01c-1.338.013-1.924-.298-2.352-1.6l-.09-.286c-.07-.21-.119-.272-.181-.286l-.033-.003h-.05l-.047.005-.09.022-.09.031-.698.279c-.677.276-1.186.41-1.774.41-.841 0-1.204-.689-.88-1.428.25-.57.543-.865 1.35-1.255l.262-.118c.282-.135.668-.375 1.042-.974.056-.109.1-.229.116-.374l.006-.114c.063-1.791.99-2.773 2.609-2.663l.183.016.427.055A5.956 5.956 0 0 0 8 2Zm.5 3.388c-.021.281-.124.482-.195.6l-.056.087c-.452.723-.755 1-1.08 1.192l-.166.09-.18.09-.177.09-.213.125a5.56 5.56 0 0 0-.108.068l-.213.144c-.343.247-.61.51-.494.628.1.102.347.05.614-.041l.231-.086.326-.127.822-.331.192-.066c.199-.062.372-.095.543-.095.592 0 .99.385 1.205 1.105.241.812.403 1.029 1.04 1.066l.135.006h.273c.273 0 .435-.018.484-.053a.208.208 0 0 0 .072-.102l.052-.138.048-.108.367-.884c.418-.97.697-1.285 1.333-1.135.231.055.457.189.644.404L14 8a5.98 5.98 0 0 0-1.67-4.153l-.936-.102-.693-.084-.538-.076c-1.17-.134-1.54.208-1.663 1.803Zm-2.898-2.89-.037.017c-.106.047-.21.097-.313.15v.071a4.53 4.53 0 0 1-.1.714l-.09.44c-.086.454-.086.681-.01.807l.032.047c.035.036.08.036.197-.06l.142-.131c.043-.043.09-.083.14-.12l.225-.165c.194-.148.348-.318.29-.642-.047-.262-.082-.38-.122-.466l-.15-.28a6.357 6.357 0 0 0-.204-.383Z"
      })
    ], -1)
  ]));
}
const En = /* @__PURE__ */ d(yn, [["render", Pn]]), On = a({ name: "IconHighlight" }), Un = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Tn(t, n, e, s, r, c) {
  return l(), i("svg", Un, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M4 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4Zm4.417 2L12.5 13h-1l-.963-2.417H5.44L4.5 13h-1l4-10h.917ZM7.84 4.534 5.918 9.417h4.147l-1.99-4.883h-.234Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Rn = /* @__PURE__ */ d(On, [["render", Tn]]), qn = a({ name: "IconInfinity" }), Gn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Qn(t, n, e, s, r, c) {
  return l(), i("svg", Gn, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/other/infinity",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M12.002 4.793C13.935 4.793 15 6.343 15 8c0 1.657-1.065 3.274-2.998 3.274-1.127 0-2.461-.835-4.002-2.505-1.54 1.67-2.875 2.505-4.002 2.505C2.065 11.274 1 9.657 1 8s1.065-3.207 2.998-3.207c1.127 0 2.461.818 4.002 2.453 1.54-1.635 2.875-2.453 4.002-2.453Zm0 1-.117.005c-.75.06-1.76.695-2.978 1.946l-.237.25.005.006-.011.012.238.258c1.215 1.279 2.224 1.93 2.97 1.998l.13.006C13.198 10.274 14 9.309 14 8c0-1.232-.718-2.126-1.842-2.201l-.156-.006Zm-8.004 0C2.785 5.793 2 6.713 2 8c0 1.309.802 2.274 1.998 2.274.757 0 1.814-.65 3.1-2.004l.237-.258L7.325 8l.005-.006-.02-.022c-1.314-1.403-2.401-2.11-3.195-2.174l-.117-.005Z"
      })
    ], -1)
  ]));
}
const jn = /* @__PURE__ */ d(qn, [["render", Qn]]), Nn = a({ name: "IconInfoFill" }), Wn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Jn(t, n, e, s, r, c) {
  return l(), i("svg", Wn, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/info-fill",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm1 5H7v6h2V6Zm0-3H7v2h2V3Z"
      })
    ], -1)
  ]));
}
const Kn = /* @__PURE__ */ d(Nn, [["render", Jn]]), Yn = a({ name: "IconInfo" }), Xn = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function no(t, n, e, s, r, c) {
  return l(), i("svg", Xn, n[0] || (n[0] = [
    o("g", {
      id: "Info",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm.668 4.06V12h-.972V6.06h.972Zm0-2.412v.972h-.972v-.972h.972Z"
      })
    ], -1)
  ]));
}
const oo = /* @__PURE__ */ d(Yn, [["render", no]]), to = a({ name: "IconInsert" }), eo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function so(t, n, e, s, r, c) {
  return l(), i("svg", eo, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M8 2.261C7.683 2.117 7.316 2 7 2c-.316 0-.683.117-1 .261V3a1 1 0 0 1-1 1v1h4V4a1 1 0 0 1-1-1v-.739ZM3 4h1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4h1v2h1V4a1 1 0 0 0-1-1H9v-.798c0-.335-.166-.649-.467-.795C8.148 1.22 7.574 1 7 1s-1.148.22-1.533.407c-.3.146-.467.46-.467.795V3H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4v-1H3V4Zm6 10V8h4v6H9ZM8 8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V8Zm2 1.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ro = /* @__PURE__ */ d(to, [["render", so]]), ao = a({ name: "IconItalic" }), io = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function lo(t, n, e, s, r, c) {
  return l(), i("svg", io, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M10 2h3v1H9.833L8.167 13H11v1H3v-1h3.167L7.833 3H5V2h5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const co = /* @__PURE__ */ d(ao, [["render", lo]]), vo = a({ name: "IconLink" }), po = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function ho(t, n, e, s, r, c) {
  return l(), i("svg", po, n[0] || (n[0] = [
    o("g", {
      id: "link",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "m7.895 5.895.701.703-1.739 1.738-.1.105c-.894.967-1.013 2.318-.265 3.067.747.747 2.088.627 3.052-.25l.105-.101 3.494-3.493.1-.105c.894-.967 1.013-2.318.265-3.067-.46-.459-1.142-.59-1.824-.42l-.791-.792c1.16-.495 2.467-.339 3.316.51 1.127 1.128 1.035 3.06-.183 4.388l-.117.123-3.608 3.608c-1.329 1.328-3.348 1.463-4.51.3-1.127-1.127-1.035-3.06.183-4.387l.117-.123 1.804-1.804ZM5.7 4.091c1.329-1.328 3.348-1.463 4.51-.3 1.127 1.127 1.035 3.06-.183 4.387l-.117.123-1.805 1.804-.702-.701 1.74-1.74.101-.105c.894-.967 1.013-2.318.265-3.067-.747-.747-2.088-.627-3.052.25l-.105.101-3.494 3.493-.1.105c-.894.967-1.013 2.318-.265 3.067.46.458 1.142.59 1.823.42l.791.792c-1.16.495-2.466.338-3.315-.51-1.127-1.128-1.035-3.06.183-4.388l.117-.123L5.7 4.091Z"
      })
    ], -1)
  ]));
}
const $o = /* @__PURE__ */ d(vo, [["render", ho]]), wo = a({ name: "IconListSearch" }), _o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function uo(t, n, e, s, r, c) {
  return l(), i("svg", _o, n[0] || (n[0] = [
    o("g", {
      id: "list-search",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M11 8a3 3 0 0 1 2.445 4.738l2.176 2.176-.707.707-2.176-2.176A3 3 0 1 1 11 8Zm-3.874 4c.092.356.23.692.41 1.001L4 13v-1h3.126ZM2 12v1H1v-1h1Zm9-3a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM7.535 9c-.179.31-.318.645-.409 1H4V9h3.535ZM2 9v1H1V9h1Zm13-3v1H4V6h11ZM2 6v1H1V6h1Zm13-3v1H4V3h11ZM2 3v1H1V3h1Z"
      })
    ], -1)
  ]));
}
const mo = /* @__PURE__ */ d(wo, [["render", uo]]), go = a({ name: "IconList" }), fo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function xo(t, n, e, s, r, c) {
  return l(), i("svg", fo, n[0] || (n[0] = [
    o("g", {
      id: "list",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M15 12v1H4v-1h11ZM2 12v1H1v-1h1Zm13-3v1H4V9h11ZM2 9v1H1V9h1Zm13-3v1H4V6h11ZM2 6v1H1V6h1Zm13-3v1H4V3h11ZM2 3v1H1V3h1Z"
      })
    ], -1)
  ]));
}
const Zo = /* @__PURE__ */ d(go, [["render", xo]]), Vo = a({ name: "IconLoader" }), Io = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Ho(t, n, e, s, r, c) {
  return l(), i("svg", Io, n[0] || (n[0] = [
    o("g", {
      id: "Loader",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M15 8a7 7 0 1 1-7-7v2a5 5 0 1 0 3.536 1.464L12.95 3.05A7 7 0 0 1 15 8Z"
      })
    ], -1)
  ]));
}
const Mo = /* @__PURE__ */ d(Vo, [["render", Ho]]), Lo = a({ name: "IconLocation" }), ko = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Bo(t, n, e, s, r, c) {
  return l(), i("svg", ko, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/other/location",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a5 5 0 0 1 5 5c0 1.418-.89 3.16-1.975 4.824l-.369.552-.187.272-.38.536-.415.571-.409.55-.94 1.254L8 15l-.324-.436-1.142-1.517-.413-.56-.416-.58-.375-.542C4.09 9.545 3 7.57 3 6a5 5 0 0 1 5-5Zm0 1a4 4 0 0 0-4 4c0 .825.42 1.955 1.22 3.329.353.606.77 1.244 1.264 1.946l.446.621.529.714.538.719 1.08-1.452.182-.25c.606-.843 1.1-1.586 1.509-2.285C11.576 7.962 12 6.83 12 6a4 4 0 0 0-4-4Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      })
    ], -1)
  ]));
}
const Co = /* @__PURE__ */ d(Lo, [["render", Bo]]), So = a({ name: "IconLocked" }), Ao = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function bo(t, n, e, s, r, c) {
  return l(), i("svg", Ao, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/toggle/locked",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 2a3 3 0 0 1 3 3v2h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V5a3 3 0 0 1 3-3Zm4 6H4v6h8V8Zm-4 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-7a2 2 0 0 0-1.995 1.85L6 5v2h4V5a2 2 0 0 0-1.85-1.995L8 3Z"
      })
    ], -1)
  ]));
}
const Do = /* @__PURE__ */ d(So, [["render", bo]]), zo = a({ name: "IconLogin" }), yo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Fo(t, n, e, s, r, c) {
  return l(), i("svg", yo, n[0] || (n[0] = [
    o("g", {
      id: "login",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "login",
        d: "M14 1v14H6v-2h1v1h6V2H7v1H6V1h8ZM7.536 4.5l3.535 3.536-3.535 3.535-.708-.707 2.365-2.365-7.157.001v-1l7.085-.001-2.293-2.292.708-.707Z"
      })
    ], -1)
  ]));
}
const Po = /* @__PURE__ */ d(zo, [["render", Fo]]), Eo = a({ name: "IconLogout" }), Oo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Uo(t, n, e, s, r, c) {
  return l(), i("svg", Oo, n[0] || (n[0] = [
    o("g", {
      id: "logout",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "logout",
        d: "M10 1v2H9V2H3v12h6v-1h1v2H2V1h8Zm.536 3.5 3.535 3.536-3.535 3.535-.708-.707 2.365-2.365-7.157.001v-1l7.085-.001-2.293-2.292.708-.707Z"
      })
    ], -1)
  ]));
}
const To = /* @__PURE__ */ d(Eo, [["render", Uo]]), Ro = a({ name: "IconMenu" }), qo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Go(t, n, e, s, r, c) {
  return l(), i("svg", qo, n[0] || (n[0] = [
    o("g", {
      id: "Menu",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "menu",
        d: "M16 12v2H0v-2h16Zm0-5v2H0V7h16Zm0-5v2H0V2h16Z"
      })
    ], -1)
  ]));
}
const Qo = /* @__PURE__ */ d(Ro, [["render", Go]]), jo = a({ name: "IconMinus" }), No = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Wo(t, n, e, s, r, c) {
  return l(), i("svg", No, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M2 7.5h12v1H2v-1Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Jo = /* @__PURE__ */ d(jo, [["render", Wo]]), Ko = a({ name: "IconNotification" }), Yo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Xo(t, n, e, s, r, c) {
  return l(), i("svg", Yo, n[0] || (n[0] = [
    o("g", {
      id: "notification",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "notification",
        d: "M2 12.5v-2L3 9V7c0-2.817 1.973-4.752 4.5-4.978V1h1v1.025a5 5 0 0 1 4.495 4.758L13 7v2l1 1.5v2h-3.5a2.5 2.5 0 1 1-5 0H2Zm4.5 0a1.5 1.5 0 0 0 3 0h-3ZM8 3a4 4 0 0 0-3.995 3.8L4 7v2.3l-1 1.467v.733h10v-.733L12 9.3V7l-.005-.2A4 4 0 0 0 8 3Z"
      })
    ], -1)
  ]));
}
const nt = /* @__PURE__ */ d(Ko, [["render", Xo]]), ot = a({ name: "IconOverflowMenuHorizontal" }), tt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function et(t, n, e, s, r, c) {
  return l(), i("svg", tt, n[0] || (n[0] = [
    o("g", {
      id: "Overflow-menu-horizontal",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "overflow-menu-vertical",
        d: "M8 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
        transform: "rotate(90 8 8)"
      })
    ], -1)
  ]));
}
const st = /* @__PURE__ */ d(ot, [["render", et]]), rt = a({ name: "IconOverflowMenuVertical" }), at = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function it(t, n, e, s, r, c) {
  return l(), i("svg", at, n[0] || (n[0] = [
    o("g", {
      id: "Overflow-menu-vertical",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "overflow-menu-vertical",
        d: "M8 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      })
    ], -1)
  ]));
}
const lt = /* @__PURE__ */ d(rt, [["render", it]]), dt = a({ name: "IconPassword" }), ct = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function vt(t, n, e, s, r, c) {
  return l(), i("svg", ct, n[0] || (n[0] = [
    o("g", {
      id: "password",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "password",
        d: "m11.818 1.546 2.636 2.636a1.864 1.864 0 0 1 0 2.636l-2.636 2.636a1.864 1.864 0 0 1-2.536.093l-1.45 1.452L7 11v.831L5.83 13 5 13v.83L3.83 15H1.002L1 12l5.374-5.38a1.864 1.864 0 0 1 .172-2.438l2.636-2.636a1.864 1.864 0 0 1 2.636 0ZM7.068 7.34l-5.069 5.073.002 1.585h1.414l.584-.584.002-1.414 1.414-.002.584-.584.002-1.414 1.415-.002 1.156-1.154-1.504-1.504Zm2.854-5.208-.081.072-2.636 2.636a.932.932 0 0 0-.072 1.237l.072.081 2.636 2.636a.932.932 0 0 0 1.237.072l.081-.072 2.636-2.636a.932.932 0 0 0 .072-1.237l-.072-.081-2.636-2.636a.932.932 0 0 0-1.237-.072Zm1.237 1.39 1.318 1.318a.466.466 0 0 1-.659.659L10.5 4.182a.466.466 0 0 1 .659-.659Z"
      })
    ], -1)
  ]));
}
const pt = /* @__PURE__ */ d(dt, [["render", vt]]), ht = a({ name: "IconPin" }), $t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function wt(t, n, e, s, r, c) {
  return l(), i("svg", $t, n[0] || (n[0] = [
    o("g", {
      id: "pin",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M9.506 2.432a.5.5 0 0 1 .779-.333l.065.054 3.546 3.477a.5.5 0 0 1-.162.82l-.086.027-1.719.36L9.48 9.211v2.869a.501.501 0 0 1-.72.45l-.071-.043-.066-.057-1.63-1.662-2.645 2.647a.5.5 0 0 1-.275.14l-.078.007H2.992a.5.5 0 0 1-.492-.41l-.008-.09v-.982a.5.5 0 0 1 .094-.292l.05-.06L5.298 9.04l-1.66-1.691a.5.5 0 0 1 .272-.844l.086-.007h2.8l2.446-2.401.265-1.665ZM5.997 9.754l-2.505 2.531v.276h.295l2.503-2.506-.122-.127-.17-.174Zm4.344-6.209-.138.873a.5.5 0 0 1-.091.218l-.053.06-2.709 2.66a.5.5 0 0 1-.253.133L7 7.499l-1.815-.001 1.094 1.113.048.035.045.042.575.606 1.533 1.562V9a.5.5 0 0 1 .057-.23l.042-.068.053-.061 2.704-2.622a.5.5 0 0 1 .156-.102l.09-.028.946-.199-2.187-2.145Z"
      })
    ], -1)
  ]));
}
const _t = /* @__PURE__ */ d(ht, [["render", wt]]), ut = a({ name: "IconPlus" }), mt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function gt(t, n, e, s, r, c) {
  return l(), i("svg", mt, n[0] || (n[0] = [
    o("g", {
      id: "plus",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M8.5 2v5.5H14v1H8.5V14h-1V8.5H2v-1h5.5V2z"
      })
    ], -1)
  ]));
}
const ft = /* @__PURE__ */ d(ut, [["render", gt]]), xt = a({ name: "IconPrinter" }), Zt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Vt(t, n, e, s, r, c) {
  return l(), i("svg", Zt, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/other/printer",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M12 2v3h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2v2H4v-2H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2V2h8Zm-1 7.01H5.02V12H5v1h6V9.01ZM14 6H2v5h2V8h8l.002.848.006.046.007.116V11H14V6Zm-3-3H5v2h6V3Z"
      })
    ], -1)
  ]));
}
const It = /* @__PURE__ */ d(xt, [["render", Vt]]), Ht = a({ name: "IconQuestionFill" }), Mt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Lt(t, n, e, s, r, c) {
  return l(), i("svg", Mt, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/question-fill",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm2.404 4.576c0 .215-.014.408-.042.581a2.365 2.365 0 0 1-.329.882c-.08.126-.166.259-.259.399a7.103 7.103 0 0 1-.364.497 7.77 7.77 0 0 0-.371.504 3.08 3.08 0 0 0-.294.546c-.08.191-.119.39-.119.595v.63H7.058v-.56c0-.355.033-.663.098-.924s.191-.523.378-.784c.15-.224.296-.434.441-.63.145-.196.27-.383.378-.56.107-.177.196-.35.266-.518.07-.168.105-.336.105-.504 0-.13-.012-.268-.035-.413a1.082 1.082 0 0 0-.147-.399.888.888 0 0 0-.315-.301c-.135-.08-.315-.119-.539-.119a.984.984 0 0 0-.805.371c-.2.247-.31.576-.329.987a59.858 59.858 0 0 0-.77-.105A30.583 30.583 0 0 0 5 5.66c.037-.439.138-.824.301-1.155.163-.331.366-.609.609-.833.243-.224.523-.392.84-.504A3.049 3.049 0 0 1 7.772 3c.868 0 1.524.233 1.967.7.443.467.665 1.092.665 1.876Zm-3.36 7.238V11.26h1.568v1.554H7.044Z"
      })
    ], -1)
  ]));
}
const kt = /* @__PURE__ */ d(Ht, [["render", Lt]]), Bt = a({ name: "IconQuestion" }), Ct = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function St(t, n, e, s, r, c) {
  return l(), i("svg", Ct, n[0] || (n[0] = [
    o("g", {
      id: "question",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 13A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm2.232-8.3c0 .192-.014.364-.042.516a2.238 2.238 0 0 1-.312.804c-.076.12-.162.252-.258.396a4.866 4.866 0 0 1-.3.39c-.112.132-.218.27-.318.414a2.74 2.74 0 0 0-.252.444 1.109 1.109 0 0 0-.102.456v.72h-.996v-.564c0-.288.034-.544.102-.768a2.03 2.03 0 0 1 .342-.648l.756-1.02c.208-.28.32-.564.336-.852 0-.168-.012-.338-.036-.51a1.294 1.294 0 0 0-.156-.468.922.922 0 0 0-.348-.342c-.152-.088-.352-.132-.6-.132-.184 0-.35.038-.498.114a1.14 1.14 0 0 0-.372.3c-.1.124-.178.266-.234.426-.056.16-.088.32-.096.48l-.996-.144c.048-.36.14-.674.276-.942a2.2 2.2 0 0 1 .504-.666c.2-.176.426-.306.678-.39.252-.084.518-.126.798-.126.696 0 1.224.192 1.584.576.36.384.54.896.54 1.536ZM7.628 12v-1.068h1.008V12H7.628Z"
      })
    ], -1)
  ]));
}
const At = /* @__PURE__ */ d(Bt, [["render", St]]), bt = a({ name: "IconRefresh" }), Dt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function zt(t, n, e, s, r, c) {
  return l(), i("svg", Dt, n[0] || (n[0] = [
    o("g", {
      id: "refresh",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M14.93 7A7 7 0 0 1 3 12.898V15H2v-4h4v1l-2.471.001A6 6 0 0 0 13.917 7h1.012Zm-1.001-6v4h-4V4h2.47A6 6 0 0 0 2.012 9.001L1 9a7 7 0 0 1 11.93-5.898V1h1Z"
      })
    ], -1)
  ]));
}
const yt = /* @__PURE__ */ d(bt, [["render", zt]]), Ft = a({ name: "IconRemove" }), Pt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Et(t, n, e, s, r, c) {
  return l(), i("svg", Pt, n[0] || (n[0] = [
    o("g", {
      id: "remove",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Path",
        d: "m8.01 7.345 3.324-3.324.665.665L8.675 8.01l3.304 3.304-.665.665L8.01 8.675 4.685 12l-.665-.665L7.345 8.01 4 4.665 4.665 4 8.01 7.345z"
      })
    ], -1)
  ]));
}
const Ot = /* @__PURE__ */ d(Ft, [["render", Et]]), Ut = a({ name: "IconSandglass" }), Tt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Rt(t, n, e, s, r, c) {
  return l(), i("svg", Tt, n[0] || (n[0] = [
    o("g", {
      id: "sandglass",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M11.992 1v1l-.117.007a1 1 0 0 0-.883.993v2l-.005.157a2.013 2.013 0 0 1-.935 1.57l-.176.103c-.498.302-.882.673-.882 1.17l.001.057c.028.469.402.822.881 1.113l.117.068c.534.303.915.868.987 1.531l.007.074.005.157v2l.007.117a1 1 0 0 0 .764.857l.112.02.117.006v1H3.997v-1l.117-.007a1 1 0 0 0 .876-.876L4.997 13v-2l.005-.157.007-.074a2.015 2.015 0 0 1 .856-1.45l.13-.08.118-.07c.43-.26.777-.573.862-.975l.018-.137L6.995 8c0-.452-.318-.8-.75-1.085l-.132-.085-.176-.103a2.005 2.005 0 0 1-.916-1.405l-.019-.165L4.997 5V3a1 1 0 0 0-.883-.993L3.997 2V1h7.995ZM7.678 13.105l-1.812.606c-.038.1-.085.198-.138.29h4.533c-.053-.092-.1-.19-.138-.29l-1.813-.606a.999.999 0 0 0-.632 0ZM7.994 8v.074a2 2 0 0 1-.999 1.658c-.537.312-.852.6-.956.972l-.027.127-.007.052L6 11l-.001 1.666 1.68-.56a.999.999 0 0 1 .632 0l1.68.56V11l-.006-.117-.007-.052c-.063-.434-.386-.753-.983-1.099a2 2 0 0 1-.998-1.658L7.994 8ZM9.99 5H6l.006.117.007.052c.063.434.386.753.983 1.099a2 2 0 0 1 .992 1.563L7.994 8a2 2 0 0 1 1-1.732c.597-.346.92-.665.983-1.099l.007-.052L9.99 5Zm.27-3H5.728c.17.294.268.636.268 1h.003l-.001 1H9.99V3h.003c0-.364.097-.706.267-1Z"
      })
    ], -1)
  ]));
}
const qt = /* @__PURE__ */ d(Ut, [["render", Rt]]), Gt = a({ name: "IconSave" }), Qt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function jt(t, n, e, s, r, c) {
  return l(), i("svg", Qt, n[0] || (n[0] = [
    o("g", {
      id: "Save",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        "fill-rule": "nonzero",
        d: "M2 14V2h9.026L14 5.001V14H2ZM5 3H3v10h2V8h6v5h2V5.413l-2-2.019V6H5V3Zm5 6H6v4h4V9Zm0-6H6v2h4V3Z"
      })
    ], -1)
  ]));
}
const Nt = /* @__PURE__ */ d(Gt, [["render", jt]]), Wt = a({ name: "IconSearch" }), Jt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Kt(t, n, e, s, r, c) {
  return l(), i("svg", Jt, n[0] || (n[0] = [
    o("g", {
      id: "search",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M6.5 1a5.5 5.5 0 0 1 4.187 9.067L15 14.5l-.5.5-4.433-4.313A5.5 5.5 0 1 1 6.5 1Zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"
      })
    ], -1)
  ]));
}
const Yt = /* @__PURE__ */ d(Wt, [["render", Kt]]), Xt = a({ name: "IconSettings" }), ne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function oe(t, n, e, s, r, c) {
  return l(), i("svg", ne, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      d: "m9.561 1.43.194 1.356c.238.08.468.176.69.286l1.097-.822a.5.5 0 0 1 .654.046l1.508 1.508a.5.5 0 0 1 .046.654l-.822 1.096c.11.222.206.453.286.69l1.357.195a.5.5 0 0 1 .429.495v2.132a.5.5 0 0 1-.43.495l-1.356.194c-.08.238-.176.468-.286.69l.822 1.097a.5.5 0 0 1-.046.654l-1.508 1.508a.5.5 0 0 1-.654.046l-1.097-.822a5.46 5.46 0 0 1-.69.286l-.194 1.357a.5.5 0 0 1-.495.429H6.934a.5.5 0 0 1-.495-.43l-.194-1.356a5.462 5.462 0 0 1-.69-.286l-1.097.822a.5.5 0 0 1-.654-.046l-1.508-1.508a.5.5 0 0 1-.046-.654l.822-1.097a5.463 5.463 0 0 1-.286-.69l-1.357-.194A.5.5 0 0 1 1 9.066V6.934a.5.5 0 0 1 .43-.495l1.356-.194c.08-.238.176-.469.286-.69L2.25 4.457a.5.5 0 0 1 .046-.654l1.508-1.508a.5.5 0 0 1 .654-.046l1.096.822c.222-.11.453-.206.69-.286l.195-1.357A.5.5 0 0 1 6.934 1h2.132a.5.5 0 0 1 .495.43ZM6.564 3.733l.584-.197L7.368 2h1.265l.22 1.537.583.197c.194.065.383.143.564.234l.552.274 1.243-.932.895.895-.932 1.243.274.552c.09.181.169.37.234.564l.197.584 1.537.22v1.265l-1.537.22-.197.583a4.449 4.449 0 0 1-.234.564l-.274.552.932 1.243-.895.895-1.243-.932-.552.274c-.181.09-.37.169-.564.234l-.584.197L8.632 14H7.368l-.22-1.537-.583-.197A4.45 4.45 0 0 1 6 12.032l-.552-.274-1.243.932-.895-.895.932-1.243L3.968 10a4.464 4.464 0 0 1-.234-.564l-.197-.584L2 8.632V7.368l1.537-.22.197-.583c.065-.194.143-.383.234-.564l.274-.552-.932-1.243.895-.895 1.243.932L6 3.968c.181-.09.37-.169.564-.234Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const te = /* @__PURE__ */ d(Xt, [["render", oe]]), ee = a({ name: "IconShoppingCart" }), se = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function re(t, n, e, s, r, c) {
  return l(), i("svg", se, n[0] || (n[0] = [
    o("g", {
      id: "shopping-cart",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M5.95 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM2.5 2h1.285l.083.007a.5.5 0 0 1 .552.324l.023.087.268 1.599c.063-.012.122-.017.181-.017h8.877a1 1 0 0 1 .987 1.164l-.667 4a1 1 0 0 1-.986.836H5.707l.167 1h6.576a.5.5 0 0 1 .09.992l-.09.008-6.918-.007-.069.007H5.45a.503.503 0 0 1-.47-.33l-.023-.088L3.526 3H2.5a.5.5 0 1 1 0-1Zm11.27 3H4.891l.718 4h7.493l.666-4Z"
      })
    ], -1)
  ]));
}
const ae = /* @__PURE__ */ d(ee, [["render", re]]), ie = a({ name: "IconSortDate" }), le = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function de(t, n, e, s, r, c) {
  return l(), i("svg", le, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/operations/sort-date",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M12 8v5.156l2.364-2.363.707.707-3.535 3.536L8 11.5l.707-.707L11 13.086V8h1ZM9.5 1a.5.5 0 0 1 .492.41L10 1.5v.502h1.002a2 2 0 0 1 1.994 1.852l.006.149v2.995h-1L12 6H1.999L2 12.026a1 1 0 0 0 .883.993l.117.007h4v1H3a2 2 0 0 1-1.995-1.85L1 12.025V4.003a2 2 0 0 1 1.85-1.995L3 2.003l1-.001V1.5a.5.5 0 0 1 .992-.09L5 1.5v.502h4V1.5a.5.5 0 0 1 .5-.5ZM9 3.002H5V3.5a.5.5 0 0 1-.992.09L4 3.5v-.498H3a1 1 0 0 0-.993.884L2 4.003 1.999 5h10.002v-.997a1 1 0 0 0-.882-.993l-.117-.007L10 3.002V3.5a.5.5 0 0 1-.992.09L9 3.5v-.498Z"
      })
    ], -1)
  ]));
}
const ce = /* @__PURE__ */ d(ie, [["render", de]]), ve = a({ name: "IconSortingDown" }), pe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function he(t, n, e, s, r, c) {
  return l(), i("svg", pe, n[0] || (n[0] = [
    o("path", { d: "M12 6H4l4 5 4-5Z" }, null, -1)
  ]));
}
const $e = /* @__PURE__ */ d(ve, [["render", he]]), we = a({ name: "IconSortingUp" }), _e = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function ue(t, n, e, s, r, c) {
  return l(), i("svg", _e, n[0] || (n[0] = [
    o("path", { d: "M12 10H4l4-5 4 5Z" }, null, -1)
  ]));
}
const me = /* @__PURE__ */ d(we, [["render", ue]]), ge = a({ name: "IconSorting" }), fe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function xe(t, n, e, s, r, c) {
  return l(), i("svg", fe, n[0] || (n[0] = [
    o("path", { d: "M12 6H4l4-5 4 5ZM12 10H4l4 5 4-5Z" }, null, -1)
  ]));
}
const Ze = /* @__PURE__ */ d(ge, [["render", xe]]), Ve = a({ name: "IconSource" }), Ie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function He(t, n, e, s, r, c) {
  return l(), i("svg", Ie, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "m9.015 1.879-3 12 .97.242 3-12-.97-.242Zm2.38 1.813-.79.615 2.947 3.782-2.94 3.594.775.633 3.445-4.212-3.438-4.412Zm-6.798.013.806.59L2.625 8.09l2.771 3.606-.792.61-3.229-4.202 3.222-4.398Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Me = /* @__PURE__ */ d(Ve, [["render", He]]), Le = a({ name: "IconStarFill" }), ke = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Be(t, n, e, s, r, c) {
  return l(), i("svg", ke, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/toggle/star-fill",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Star",
        "fill-rule": "nonzero",
        d: "m6.066 5.938-4.448.092-.086.008a.5.5 0 0 0-.206.89L4.87 9.616l-1.288 4.26-.018.084a.5.5 0 0 0 .782.47L8 11.89l3.653 2.542.074.043a.5.5 0 0 0 .69-.598l-1.289-4.26 3.546-2.688.064-.057a.5.5 0 0 0-.356-.841l-4.449-.092-1.46-4.202a.5.5 0 0 0-.945 0L6.066 5.938Z"
      })
    ], -1)
  ]));
}
const Ce = /* @__PURE__ */ d(Le, [["render", Be]]), Se = a({ name: "IconStar" }), Ae = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function be(t, n, e, s, r, c) {
  return l(), i("svg", Ae, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/toggle/star",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Star",
        "fill-rule": "nonzero",
        d: "m6.066 5.938-4.448.092-.086.008a.5.5 0 0 0-.206.89L4.87 9.616l-1.288 4.26-.018.084a.5.5 0 0 0 .782.47L8 11.89l3.653 2.542.074.043a.5.5 0 0 0 .69-.598l-1.289-4.26 3.546-2.688.064-.057a.5.5 0 0 0-.356-.841l-4.449-.092-1.46-4.202a.5.5 0 0 0-.945 0L6.066 5.938ZM8 3.423l1.103 3.173.036.08a.5.5 0 0 0 .426.256L12.924 7l-2.677 2.03-.066.06a.5.5 0 0 0-.11.483l.972 3.215-2.757-1.918-.077-.044a.5.5 0 0 0-.495.044l-2.758 1.918.974-3.215.018-.087a.5.5 0 0 0-.195-.456L3.075 7l3.36-.068a.5.5 0 0 0 .462-.336L8 3.423Z"
      })
    ], -1)
  ]));
}
const De = /* @__PURE__ */ d(Se, [["render", be]]), ze = a({ name: "IconTabBackward" }), ye = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Fe(t, n, e, s, r, c) {
  return l(), i("svg", ye, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M14 2.5H2v1h12v-1Zm0 10H2v1h12v-1Zm-7-5h7v1H7v-1ZM14 5H7v1h7V5Zm-7 5h7v1H7v-1ZM2 8l3-3v6L2 8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Pe = /* @__PURE__ */ d(ze, [["render", Fe]]), Ee = a({ name: "IconTabForward" }), Oe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Ue(t, n, e, s, r, c) {
  return l(), i("svg", Oe, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M14 2.5H2v1h12v-1Zm0 10H2v1h12v-1Zm-7-5h7v1H7v-1ZM14 5H7v1h7V5Zm-7 5h7v1H7v-1ZM5 8 2 5v6l3-3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Te = /* @__PURE__ */ d(Ee, [["render", Ue]]), Re = a({ name: "IconTelegram" }), qe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Ge(t, n, e, s, r, c) {
  return l(), i("svg", qe, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/social/telegram",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M14.76 2.158c.2.172.276.493.224.96l-2.12 9.961c-.105.495-.293.787-.564.876-.271.09-.6.045-.984-.134l-3.723-2.746c-.517-.36-.776-.67-.776-.932 0-.261.203-.551.608-.87l4.02-4.027c.04-.116.028-.21-.033-.28-.06-.071-.176-.071-.345 0L5.37 8.72c-.239.178-.447.296-.626.354-.178.058-.399.058-.661 0l-2.513-.878C1.19 8.066 1 7.86 1 7.581c0-.28.14-.493.417-.641l12.431-4.876c.407-.11.71-.078.912.094Z"
      })
    ], -1)
  ]));
}
const Qe = /* @__PURE__ */ d(Re, [["render", Ge]]), je = a({ name: "IconTimer" }), Ne = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function We(t, n, e, s, r, c) {
  return l(), i("svg", Ne, n[0] || (n[0] = [
    o("g", {
      id: "timer",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "timer",
        d: "M8 1a7 7 0 1 1-5 11.898V15H2v-4h4v1l-2.471.001A6 6 0 1 0 8 2V1Zm0 3v4.593l2.536 2.535-.708.708L7 9.007 7.007 9H7V4h1ZM1.037 7.257l.995.104a6.055 6.055 0 0 0 .03 1.496l.037.219-.984.18L1.073 9a7.1 7.1 0 0 1-.06-1.442l.024-.3Zm1.525-3.674.776.63c-.29.357-.537.746-.737 1.158l-.142.314-.923-.385a7.01 7.01 0 0 1 .822-1.453l.204-.264Zm3.297-2.26.305.953c-.438.14-.857.33-1.25.566l-.289.186-.563-.827c.456-.31.951-.569 1.478-.766l.32-.111Z"
      })
    ], -1)
  ]));
}
const Je = /* @__PURE__ */ d(je, [["render", We]]), Ke = a({ name: "IconTool" }), Ye = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function Xe(t, n, e, s, r, c) {
  return l(), i("svg", Ye, n[0] || (n[0] = [
    o("g", {
      id: "tool",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M10.886 5.71a5.216 5.216 0 0 1-.44 1.854c.084.059.163.127.239.202l3.758 3.759a2 2 0 0 1 0 2.828l-.099.1a2 2 0 0 1-2.828 0l-3.76-3.76a2.015 2.015 0 0 1-.206-.242 5.191 5.191 0 0 1-1.84.435c-2.728.13-4.834-1.977-4.704-4.705a5.291 5.291 0 0 1 .765-2.48L4.63 6.559a1 1 0 0 0 1.32.083l.094-.083.782-.782a1 1 0 0 0 .083-1.32l-.083-.094L4.043 1.58a5.249 5.249 0 0 1 2.138-.575c2.728-.13 4.835 1.976 4.705 4.705ZM6.422 2l-.193.005c-.086.004-.17.01-.256.02l-.064.008 1.665 1.668.124.142a2 2 0 0 1-.047 2.51l-.119.131-.827.824-.142.123a2 2 0 0 1-2.51-.046l-.131-.12-1.807-1.807-.052.247a4.132 4.132 0 0 0-.037.26l-.021.264c-.102 2.139 1.519 3.76 3.658 3.658.425-.02.844-.107 1.246-.255l.24-.096.738-.324.473.652.05.063.054.06 3.759 3.758a1 1 0 0 0 1.32.083l.094-.083.1-.099a1 1 0 0 0 .082-1.32l-.083-.094-3.759-3.759-.055-.051-.055-.043-.664-.472.328-.746c.21-.479.332-.985.356-1.498C9.986 3.59 8.465 2.001 6.422 2Z"
      })
    ], -1)
  ]));
}
const n3 = /* @__PURE__ */ d(Ke, [["render", Xe]]), o3 = a({ name: "IconTruck" }), t3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function e3(t, n, e, s, r, c) {
  return l(), i("svg", t3, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/other/truck",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Combined-Shape",
        d: "M6 12a2 2 0 1 1-4 0h-.5a.5.5 0 0 1-.492-.41L1 11.5v-9l.008-.09L1 2.498a.5.5 0 0 1 .41-.492l.09-.008h9a.5.5 0 0 1 .492.41l.008.09V3h1.673a.5.5 0 0 1 .393.191l.05.078 1.827 3.499a.5.5 0 0 1 .05.151L15 7V11.5a.5.5 0 0 1-.41.492L14.5 12h-2a2 2 0 1 1-4 0H6Zm-2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm6.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM10 2.998H2v8.001h.268a2 2 0 0 1 3.464 0h3.036A2.004 2.004 0 0 1 10 10.064V2.998Zm4 5.001h-3l.001 2.064c.525.136.966.479 1.231.937H14V8ZM12.369 4H11v3h2.936l-1.567-3Z"
      })
    ], -1)
  ]));
}
const s3 = /* @__PURE__ */ d(o3, [["render", e3]]), r3 = a({ name: "IconUnderline" }), a3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function i3(t, n, e, s, r, c) {
  return l(), i("svg", a3, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M4 2h2v7a2 2 0 1 0 4 0V2h2v7a4 4 0 0 1-8 0V2Zm9 13v-1H3v1h10Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const l3 = /* @__PURE__ */ d(r3, [["render", i3]]), d3 = a({ name: "IconUnlockedLeft" }), c3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function v3(t, n, e, s, r, c) {
  return l(), i("svg", c3, n[0] || (n[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M4 2a3 3 0 0 0-3 3h1a2 2 0 0 1 1.85-1.995L4 3a2 2 0 0 1 1.995 1.85L6 5v2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7V5a3 3 0 0 0-3-3Zm0 6h8v6H4V8Zm4 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const p3 = /* @__PURE__ */ d(d3, [["render", v3]]), h3 = a({ name: "IconUnlocked" }), $3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function w3(t, n, e, s, r, c) {
  return l(), i("svg", $3, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/toggle/unlocked",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 2a3 3 0 0 1 3 3h-1a2 2 0 0 0-1.85-1.995L8 3a2 2 0 0 0-1.995 1.85L6 5v2h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V5a3 3 0 0 1 3-3Zm4 6H4v6h8V8Zm-4 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      })
    ], -1)
  ]));
}
const _3 = /* @__PURE__ */ d(h3, [["render", w3]]), u3 = a({ name: "IconUpload" }), m3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function g3(t, n, e, s, r, c) {
  return l(), i("svg", m3, n[0] || (n[0] = [
    o("g", { id: "icon-upload" }, [
      o("path", {
        id: "Shape",
        "fill-rule": "evenodd",
        d: "m8.036 1 3.535 3.536-.707.707L8.5 2.88v8.155h-1V2.95L5.207 5.243 4.5 4.536 8.036 1ZM15 15v-3h-1l.001 2H2v-2H1v3h14Z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]));
}
const f3 = /* @__PURE__ */ d(u3, [["render", g3]]), x3 = a({ name: "IconUserAvatar" }), Z3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function V3(t, n, e, s, r, c) {
  return l(), i("svg", Z3, n[0] || (n[0] = [
    o("g", {
      id: "user-avatar",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "user",
        d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 9.5a3 3 0 0 0-2.986 2.705c.88.506 1.9.795 2.986.795 1.087 0 2.107-.29 2.986-.795A3 3 0 0 0 8 10.5ZM8 2a6 6 0 0 0-3.878 10.579l.002-.07a4.002 4.002 0 0 1 7.755.011.172.172 0 0 1 .004.054A6 6 0 0 0 8 2Zm0 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      })
    ], -1)
  ]));
}
const I3 = /* @__PURE__ */ d(x3, [["render", V3]]), H3 = a({ name: "IconUserGroup" }), M3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function L3(t, n, e, s, r, c) {
  return l(), i("svg", M3, n[0] || (n[0] = [
    o("g", {
      id: "user-group",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "icon",
        d: "M8 7a4 4 0 0 1 3.564 2.182A2.5 2.5 0 0 1 15 11.5V15H1v-3.5a2.5 2.5 0 0 1 3.437-2.318A3.998 3.998 0 0 1 8 7Zm0 1a3 3 0 0 0-3 3v3h5.999v-3.029l-.004-.147A3 3 0 0 0 8 8Zm4.5 2c-.174 0-.342.03-.5.085V14h2v-2.5a1.5 1.5 0 0 0-1.5-1.5Zm-9 0a1.5 1.5 0 0 0-1.493 1.356L2 11.5V14h2v-3.915A1.499 1.499 0 0 0 3.5 10ZM13 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM3 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm10 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm5-4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      })
    ], -1)
  ]));
}
const k3 = /* @__PURE__ */ d(H3, [["render", L3]]), B3 = a({ name: "IconVisibilityOff" }), C3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function S3(t, n, e, s, r, c) {
  return l(), i("svg", C3, n[0] || (n[0] = [
    o("g", {
      id: "view-off",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "m13.732 2.267.75.75-1.749 1.75C14.195 5.972 15 7.447 15 8c0 1-2.625 5-7 5a7.064 7.064 0 0 1-2.885-.616L3.017 14.48l-.75-.75L13.732 2.267Zm-1.713 3.214-1.285 1.283a3 3 0 0 1-3.97 3.97l-.883.883A6.04 6.04 0 0 0 8 12c1.71 0 3.25-.713 4.493-1.899a7.19 7.19 0 0 0 1.192-1.47l.123-.218.093-.186.083-.186L14 8l-.036-.088-.079-.173a4.868 4.868 0 0 0-.2-.37 7.19 7.19 0 0 0-1.192-1.47 7.816 7.816 0 0 0-.474-.418ZM8 3c1.123 0 2.131.264 3.009.673l-.761.76A6.047 6.047 0 0 0 8 4c-1.71 0-3.25.713-4.493 1.899a7.19 7.19 0 0 0-1.192 1.47l-.123.218-.093.186-.083.186L2 8l.036.088.079.173c.05.104.117.232.2.37a7.19 7.19 0 0 0 1.192 1.47c.185.177.377.343.575.498l-.715.715C1.842 10.094 1 8.566 1 8c0-1 2.625-5 7-5Zm1.95 4.551-2.4 2.398A2 2 0 0 0 9.95 7.551ZM8 5c.488 0 .95.117 1.357.324l-.765.765a2 2 0 0 0-2.503 2.503l-.765.765A3 3 0 0 1 8 5Z"
      })
    ], -1)
  ]));
}
const A3 = /* @__PURE__ */ d(B3, [["render", S3]]), b3 = a({ name: "IconVisibilityOn" }), D3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function z3(t, n, e, s, r, c) {
  return l(), i("svg", D3, n[0] || (n[0] = [
    o("g", {
      id: "view",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M8 3c4.375 0 7 4 7 5s-2.625 5-7 5-7-4-7-5 2.625-5 7-5Zm0 1c-1.71 0-3.25.713-4.493 1.899a7.19 7.19 0 0 0-1.192 1.47l-.123.218C2.066 7.826 2 7.997 2 8l.036.088.079.173c.05.104.117.232.2.37a7.19 7.19 0 0 0 1.192 1.47C4.75 11.287 6.29 12 8 12c1.71 0 3.25-.713 4.493-1.899a7.19 7.19 0 0 0 1.192-1.47l.123-.218c.126-.239.192-.41.192-.413l-.036-.088a4.75 4.75 0 0 0-.279-.543 7.19 7.19 0 0 0-1.192-1.47C11.25 4.713 9.71 4 8 4Zm0 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      })
    ], -1)
  ]));
}
const y3 = /* @__PURE__ */ d(b3, [["render", z3]]), F3 = a({ name: "IconVk" }), P3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function E3(t, n, e, s, r, c) {
  return l(), i("svg", P3, n[0] || (n[0] = [
    o("g", {
      id: "CDS-Visual-language/Icons/16/social/vk",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "M3.272 4c0 1.705.161 2.854.809 3.934.647 1.08 1.752 1.92 2.696 2.162V4h2.335v3.599c.95-.48 1.619-.937 2.006-1.371.388-.434.778-1.177 1.172-2.228h2.271c-.184 1.074-.56 2.034-1.128 2.879-.567.845-1.18 1.369-1.837 1.572 1.107.809 1.88 1.505 2.315 2.088.437.583.8 1.403 1.089 2.461h-2.418c-.588-1.176-1.076-1.94-1.464-2.29-.387-.35-1.056-.63-2.006-.843V13c-2.631-.046-4.64-.866-6.03-2.461C1.695 8.944 1 6.764 1 4h2.272Z"
      })
    ], -1)
  ]));
}
const O3 = /* @__PURE__ */ d(F3, [["render", E3]]), U3 = a({ name: "IconWhatsapp" }), T3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function R3(t, n, e, s, r, c) {
  return l(), i("svg", T3, n[0] || (n[0] = [
    o("path", { d: "M4.61 4.865a.52.52 0 0 1 .367-.23l.48-.067a.273.273 0 0 1 .271.13l.891 1.485c.048.08.052.178.011.26l-.396.809a.267.267 0 0 0 .02.27 5.421 5.421 0 0 0 2.669 2.011.267.267 0 0 0 .264-.056l.668-.603a.273.273 0 0 1 .253-.061l1.673.447a.273.273 0 0 1 .2.225l.067.48a.52.52 0 0 1-.119.415c-1.295 1.485-2.532 1.24-5.269-.622-2.543-2.117-3.12-3.24-2.05-4.893Z" }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      d: "m1 15 3.575-.894a7 7 0 1 0-2.681-2.681L1 15Zm1.96-3.718C2.385 10.258 2 9.192 2 8a6 6 0 1 1 6 6c-1.192 0-2.258-.385-3.282-.96l-2.344.586.586-2.344Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const q3 = /* @__PURE__ */ d(U3, [["render", R3]]), G3 = a({ name: "IconWinner" }), Q3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function j3(t, n, e, s, r, c) {
  return l(), i("svg", Q3, n[0] || (n[0] = [
    o("g", {
      id: "winner",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "winner",
        d: "M3 7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1V1h8v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a3 3 0 0 1-3 3h-.5v4H11v1H5v-1h2.5v-4H7a3 3 0 0 1-3-3H3Zm8-5H5v5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V2ZM4 3H3v3h1V3Zm9 0h-1v3h1V3Z"
      })
    ], -1)
  ]));
}
const N3 = /* @__PURE__ */ d(G3, [["render", j3]]), W3 = a({ name: "IconWorkspace" }), J3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function K3(t, n, e, s, r, c) {
  return l(), i("svg", J3, n[0] || (n[0] = [
    o("g", {
      id: "workspace",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        d: "M14 8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h5Zm0 1H9v5h5V9ZM6 8a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h4Zm0 1H2v3h4V9Zm8-8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h3ZM8 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6Zm6 1h-3v4h3V2ZM8 2H2v4h6V2Z"
      })
    ], -1)
  ]));
}
const Y3 = /* @__PURE__ */ d(W3, [["render", K3]]), X3 = a({ name: "IconYoutube" }), n5 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};
function o5(t, n, e, s, r, c) {
  return l(), i("svg", n5, n[0] || (n[0] = [
    o("g", {
      id: "youtube",
      "fill-rule": "evenodd",
      "stroke-width": "1"
    }, [
      o("path", {
        id: "Shape",
        "fill-rule": "nonzero",
        d: "m9.399 3.019 1.507.076c1.555.12 2.593.354 3.114.7C14.673 4.22 15 5.62 15 8s-.327 3.802-.98 4.268c-.757.4-2.05.654-3.881.758l-.669.03c-.23.009-.467.015-.713.02L8 13.08l-.757-.006c-.245-.004-.483-.01-.713-.018l-.667-.03c-1.828-.105-3.116-.358-3.863-.759-.667-.464-1-1.851-1-4.162s.345-3.748 1.036-4.31c.467-.327 1.4-.553 2.798-.678l1.606-.094L9.4 3.019ZM6.452 4.025l-1.536.087-.43.042-.896.126c-.456.085-.768.184-.923.291-.36.294-.64 1.396-.665 3.251L2 8.106c0 1.811.227 2.92.49 3.262l.047.051.049.024c.555.258 1.5.446 2.81.549l1.715.08h1.78l1.43-.06c1.464-.096 2.511-.293 3.116-.571l.038-.02c.263-.269.501-1.345.523-3.146a40.66 40.66 0 0 0-.012-1.06l-.103-1.27c-.103-.77-.262-1.216-.417-1.317-.219-.145-.633-.272-1.23-.373l-.38-.057-.653-.073-1.02-.073-1.186-.042L8 4l-1.548.025Zm.012 2.08L10.192 8 6.464 9.948V6.105Z"
      })
    ], -1)
  ]));
}
const t5 = /* @__PURE__ */ d(X3, [["render", o5]]), e5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconAdd: $,
  IconAdministrator: m,
  IconAlert: M,
  IconAlertFill: Z,
  IconAnalog: C,
  IconArrowDown: D,
  IconArrowLeft: Q,
  IconArrowLeftBottom: P,
  IconArrowLeftTop: T,
  IconArrowRight: s1,
  IconArrowRightBottom: J,
  IconArrowRightTop: n1,
  IconArrowUp: l1,
  IconArrowsVertical: p1,
  IconBold: _1,
  IconBookmark: I1,
  IconBookmarkFill: f1,
  IconCalendar: k1,
  IconCardBank: A1,
  IconCategory: y1,
  IconCheck: q1,
  IconCheckFill: O1,
  IconCheckbox: Y1,
  IconCheckboxFill: N1,
  IconChevronDown: t0,
  IconChevronLeft: a0,
  IconChevronRight: c0,
  IconChevronUp: $0,
  IconChocholateMenu: m0,
  IconChocolateMenu: Z0,
  IconClock: C0,
  IconClockFill: M0,
  IconCollapse: D0,
  IconComment: P0,
  IconCompany: T0,
  IconCompare: Q0,
  IconCopy: J0,
  IconDataCards: n2,
  IconDelete: s2,
  IconDirectory: p2,
  IconDirectoryOpen: l2,
  IconDoc: f2,
  IconDocDownload: _2,
  IconDownload: I2,
  IconDraggable: k2,
  IconEdit: A2,
  IconEducation: y2,
  IconEnter: O2,
  IconError: N2,
  IconErrorFill: q2,
  IconExpand: Y2,
  IconExternal: tn,
  IconFacebook: vn,
  IconFacebookFill: an,
  IconFill: wn,
  IconFilters: gn,
  IconFlag: Vn,
  IconFormat: Ln,
  IconFormula: Sn,
  IconFunnel: zn,
  IconGlobe: En,
  IconHighlight: Rn,
  IconInfinity: jn,
  IconInfo: oo,
  IconInfoFill: Kn,
  IconInsert: ro,
  IconItalic: co,
  IconLink: $o,
  IconList: Zo,
  IconListSearch: mo,
  IconLoader: Mo,
  IconLocation: Co,
  IconLocked: Do,
  IconLogin: Po,
  IconLogout: To,
  IconMenu: Qo,
  IconMinus: Jo,
  IconNotification: nt,
  IconOverflowMenuHorizontal: st,
  IconOverflowMenuVertical: lt,
  IconPassword: pt,
  IconPin: _t,
  IconPlus: ft,
  IconPrinter: It,
  IconQuestion: At,
  IconQuestionFill: kt,
  IconRefresh: yt,
  IconRemove: Ot,
  IconSandglass: qt,
  IconSave: Nt,
  IconSearch: Yt,
  IconSettings: te,
  IconShoppingCart: ae,
  IconSortDate: ce,
  IconSorting: Ze,
  IconSortingDown: $e,
  IconSortingUp: me,
  IconSource: Me,
  IconStar: De,
  IconStarFill: Ce,
  IconTabBackward: Pe,
  IconTabForward: Te,
  IconTelegram: Qe,
  IconTimer: Je,
  IconTool: n3,
  IconTruck: s3,
  IconUnderline: l3,
  IconUnlocked: _3,
  IconUnlockedLeft: p3,
  IconUpload: f3,
  IconUserAvatar: I3,
  IconUserGroup: k3,
  IconVisibilityOff: A3,
  IconVisibilityOn: y3,
  IconVk: O3,
  IconWhatsapp: q3,
  IconWinner: N3,
  IconWorkspace: Y3,
  IconYoutube: t5
}, Symbol.toStringTag, { value: "Module" })), r5 = {
  install(t) {
    Object.entries(e5).forEach(([n, e]) => {
      t.component(n, e);
    });
  }
}, a5 = [
  "add",
  "administrator",
  "alert-fill",
  "alert",
  "analog",
  "arrow-down",
  "arrow-left-bottom",
  "arrow-left-top",
  "arrow-left",
  "arrow-right-bottom",
  "arrow-right-top",
  "arrow-right",
  "arrow-up",
  "arrows-vertical",
  "bold",
  "bookmark-fill",
  "bookmark",
  "calendar",
  "card-bank",
  "category",
  "check-fill",
  "check",
  "checkbox-fill",
  "checkbox",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "chocholate-menu",
  "chocolate-menu",
  "clock-fill",
  "clock",
  "collapse",
  "comment",
  "company",
  "compare",
  "copy",
  "data-cards",
  "delete",
  "directory-open",
  "directory",
  "doc-download",
  "doc",
  "download",
  "draggable",
  "edit",
  "education",
  "enter",
  "error-fill",
  "error",
  "expand",
  "external",
  "facebook-fill",
  "facebook",
  "fill",
  "filters",
  "flag",
  "format",
  "formula",
  "funnel",
  "globe",
  "highlight",
  "infinity",
  "info-fill",
  "info",
  "insert",
  "italic",
  "link",
  "list-search",
  "list",
  "loader",
  "location",
  "locked",
  "login",
  "logout",
  "menu",
  "minus",
  "notification",
  "overflow-menu-horizontal",
  "overflow-menu-vertical",
  "password",
  "pin",
  "plus",
  "printer",
  "question-fill",
  "question",
  "refresh",
  "remove",
  "sandglass",
  "save",
  "search",
  "settings",
  "shopping-cart",
  "sort-date",
  "sorting-down",
  "sorting-up",
  "sorting",
  "source",
  "star-fill",
  "star",
  "tab-backward",
  "tab-forward",
  "telegram",
  "timer",
  "tool",
  "truck",
  "underline",
  "unlocked-left",
  "unlocked",
  "upload",
  "user-avatar",
  "user-group",
  "visibility-off",
  "visibility-on",
  "vk",
  "whatsapp",
  "winner",
  "workspace",
  "youtube"
];
export {
  r5 as CdsIcons,
  $ as IconAdd,
  m as IconAdministrator,
  M as IconAlert,
  Z as IconAlertFill,
  C as IconAnalog,
  D as IconArrowDown,
  Q as IconArrowLeft,
  P as IconArrowLeftBottom,
  T as IconArrowLeftTop,
  s1 as IconArrowRight,
  J as IconArrowRightBottom,
  n1 as IconArrowRightTop,
  l1 as IconArrowUp,
  p1 as IconArrowsVertical,
  _1 as IconBold,
  I1 as IconBookmark,
  f1 as IconBookmarkFill,
  k1 as IconCalendar,
  A1 as IconCardBank,
  y1 as IconCategory,
  q1 as IconCheck,
  O1 as IconCheckFill,
  Y1 as IconCheckbox,
  N1 as IconCheckboxFill,
  t0 as IconChevronDown,
  a0 as IconChevronLeft,
  c0 as IconChevronRight,
  $0 as IconChevronUp,
  m0 as IconChocholateMenu,
  Z0 as IconChocolateMenu,
  C0 as IconClock,
  M0 as IconClockFill,
  D0 as IconCollapse,
  P0 as IconComment,
  T0 as IconCompany,
  Q0 as IconCompare,
  J0 as IconCopy,
  n2 as IconDataCards,
  s2 as IconDelete,
  p2 as IconDirectory,
  l2 as IconDirectoryOpen,
  f2 as IconDoc,
  _2 as IconDocDownload,
  I2 as IconDownload,
  k2 as IconDraggable,
  A2 as IconEdit,
  y2 as IconEducation,
  O2 as IconEnter,
  N2 as IconError,
  q2 as IconErrorFill,
  Y2 as IconExpand,
  tn as IconExternal,
  vn as IconFacebook,
  an as IconFacebookFill,
  wn as IconFill,
  gn as IconFilters,
  Vn as IconFlag,
  Ln as IconFormat,
  Sn as IconFormula,
  zn as IconFunnel,
  En as IconGlobe,
  Rn as IconHighlight,
  jn as IconInfinity,
  oo as IconInfo,
  Kn as IconInfoFill,
  ro as IconInsert,
  co as IconItalic,
  $o as IconLink,
  Zo as IconList,
  mo as IconListSearch,
  Mo as IconLoader,
  Co as IconLocation,
  Do as IconLocked,
  Po as IconLogin,
  To as IconLogout,
  Qo as IconMenu,
  Jo as IconMinus,
  nt as IconNotification,
  st as IconOverflowMenuHorizontal,
  lt as IconOverflowMenuVertical,
  pt as IconPassword,
  _t as IconPin,
  ft as IconPlus,
  It as IconPrinter,
  At as IconQuestion,
  kt as IconQuestionFill,
  yt as IconRefresh,
  Ot as IconRemove,
  qt as IconSandglass,
  Nt as IconSave,
  Yt as IconSearch,
  te as IconSettings,
  ae as IconShoppingCart,
  ce as IconSortDate,
  Ze as IconSorting,
  $e as IconSortingDown,
  me as IconSortingUp,
  Me as IconSource,
  De as IconStar,
  Ce as IconStarFill,
  Pe as IconTabBackward,
  Te as IconTabForward,
  Qe as IconTelegram,
  Je as IconTimer,
  n3 as IconTool,
  s3 as IconTruck,
  l3 as IconUnderline,
  _3 as IconUnlocked,
  p3 as IconUnlockedLeft,
  f3 as IconUpload,
  I3 as IconUserAvatar,
  k3 as IconUserGroup,
  A3 as IconVisibilityOff,
  y3 as IconVisibilityOn,
  O3 as IconVk,
  q3 as IconWhatsapp,
  N3 as IconWinner,
  Y3 as IconWorkspace,
  t5 as IconYoutube,
  a5 as allowedIcons,
  r5 as default,
  e5 as icons
};
